// extracted by mini-css-extract-plugin
export var quillEditor = "_ka-1";
export var variable = "_ka-0";